import { useContext } from 'react';
import UserAuthContext from '../context/UserAuthProvider';

const useUserAuth = () => {
  return useContext(UserAuthContext);
}

export default useUserAuth;